// extracted by mini-css-extract-plugin
export default {"wrapper":"RegionSelect_wrapper__9FoYa","select":"RegionSelect_select__mH8ul"};